import { render, staticRenderFns } from "./BeneficiaryDetails.vue?vue&type=template&id=48b804a4"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports